import React from 'react';

interface ILocationIcon {
  width?: number;
  height?: number;
  fill?: string;
}
const LocationIcon: React.FC<ILocationIcon> = props => {
  const { height = 12, width = 10, fill = '#3B64F4' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00007 0C3.86343 0 2.77334 0.451529 1.96961 1.25526C1.16588 2.05898 0.714355 3.14907 0.714355 4.28571C0.714355 6.49714 4.25436 11.2886 4.65721 11.8286C4.69713 11.8818 4.7489 11.925 4.80841 11.9548C4.86792 11.9845 4.93354 12 5.00007 12C5.06661 12 5.13223 11.9845 5.19173 11.9548C5.25124 11.925 5.30301 11.8818 5.34293 11.8286C5.74579 11.2886 9.28579 6.49714 9.28579 4.28571C9.28579 3.72291 9.17493 3.16561 8.95956 2.64564C8.74418 2.12568 8.4285 1.65322 8.03053 1.25526C7.63257 0.857291 7.16011 0.541608 6.64014 0.326231C6.12018 0.110853 5.56288 0 5.00007 0V0ZM5.00007 5.57143C4.74578 5.57143 4.4972 5.49602 4.28577 5.35475C4.07433 5.21347 3.90954 5.01267 3.81223 4.77774C3.71491 4.5428 3.68945 4.28429 3.73906 4.03488C3.78867 3.78548 3.91112 3.55639 4.09093 3.37658C4.27074 3.19677 4.49984 3.07431 4.74924 3.0247C4.99865 2.9751 5.25716 3.00056 5.49209 3.09787C5.72703 3.19518 5.92783 3.35998 6.0691 3.57141C6.21038 3.78284 6.28579 4.03142 6.28579 4.28571C6.28579 4.62671 6.15033 4.95373 5.90921 5.19485C5.66809 5.43597 5.34106 5.57143 5.00007 5.57143Z"
        fill={fill}
      />
    </svg>
  );
};

export default LocationIcon;
